import React from "react";
import {
  Box,
  Grid,
  Typography,
  Button,
  IconButton,
  Stack,
} from "@mui/material";
import { background, orange } from "../../theme/colors";
import theme from "../../theme/theme";
import { IoLogoGithub, IoLogoInstagram, IoLogoLinkedin } from "react-icons/io5";
import { SiLeetcode } from "react-icons/si";

const HeroSection = () => {
  return (
    <Box
      id="home"
      component="section"
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        backgroundColor: background,
        border: "1px solide red",
        // px: { xs: 2, md: 8 },
        pb: { xs: 6, md: 0 },
      }}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="space-evenly"
        width="100vw"
        direction={{ xs: "column-reverse", md: "row" }} // Image first on mobile
      >
        {/* Text Content */}
        <Grid
          item
          xs={12}
          md={4}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            textAlign: { xs: "center", md: "left" },
            border: "1px solide yellow",
          }}
        >
          <Typography variant="h6" color={orange[500]}>
            Hi, It's
          </Typography>

          <Typography
            variant="h2"
            sx={{
              fontWeight: 700,
              fontSize: { xs: "2rem", md: "3rem" },

              fontFamily: "Poppins, sans-serif",
            }}
          >
            Pratik Shinde
          </Typography>
          <Typography
            variant="h5"
            sx={{
              //   fontWeight: 400,
              //   fontSize: { xs: "1rem", md: "1.25rem" },
              mb: 1,
              color: "text.secondary",
              display: "flex",
              flexDirection: { xs: "column", md: "row" },
            }}
          >
            And I'm a{" "}
            <Typography variant="h5" sx={{ ml: 1 }} color={orange[500]}>
              Full-Stack Developer
            </Typography>
          </Typography>
          <Stack
            direction="row"
            spacing={2}
            justifyContent={{ xs: "center", md: "flex-start" }}
            sx={{ mb: 2 }}
          >
            <IconButton
              target="_blank"
              href="https://github.com/pratik7262"
              aria-label="GitHub"
            >
              <IoLogoGithub />
            </IconButton>
            <IconButton
              href="https://leetcode.com/u/pratik_7262/"
              target="_blank"
              aria-label="Leetcode"
            >
              <SiLeetcode />
            </IconButton>
            <IconButton
              href="https://www.linkedin.com/in/pratikshinde7262/"
              target="_blank"
              aria-label="LinkedIn"
            >
              <IoLogoLinkedin />
            </IconButton>
            <IconButton
              href="https://instagram.com/pratik_72.62"
              target="_blank"
              aria-label="Instagram"
            >
              <IoLogoInstagram />
            </IconButton>
          </Stack>
          <Button
            variant="contained"
            color="primary"
            size="small"
            sx={{
              color: theme.palette.text.primary,
              px: 2,
              py: 1,
              fontSize: "1rem",
              textTransform: "none",
              alignSelf: { xs: "center", md: "flex-start" },
              width: { xs: "80%", md: "55%" },
              borderRadius: 8,
            }}
            href="./docs/Resume.pdf"
            download="PratikShinde_Resume.pdf"
          >
            Download CV
          </Button>
        </Grid>

        {/* Image */}
        <Grid
          item
          xs={12}
          md={8}
          sx={{
            display: "flex",
            justifyContent: "center",
            border: "1px solide blue",
          }}
        >
          <Box
            component="img"
            src="./images/banner2x.png" // Replace with exported PNG
            alt="banner"
            sx={{
              width: "100%",
              maxWidth: { xs: 300, sm: 400, md: 450 },
              height: "auto",
              borderRadius: 2,
            }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default HeroSection;
